import {cn} from '../../lib/utils';
import {Badge} from '../Badge';
import {Icon} from '../Icon';
import {Tooltip} from '../Tooltip';

import type {ComponentProps, ReactNode} from 'react';

export interface LockTooltipProps {
  /** Explanation shown on hover for why the field is locked. Omit to show the glyph with no tooltip. */
  content?: ReactNode;
  /** Shows a bordered lock pill with this text instead of the bare glyph. */
  label?: ReactNode;
  side?: ComponentProps<typeof Tooltip>['side'];
  className?: string;
}

/** Lock glyph (or labelled lock pill) marking a permanently non-editable field — used next to a `Field` label. */
export function LockTooltip({content, label, side, className}: LockTooltipProps) {
  return (
    <Tooltip content={content} side={side}>
      {label ? (
        <Badge variant="neutral" size="sm" className={className}>
          <Icon name="lock" className="size-3" />
          {label}
        </Badge>
      ) : (
        <Icon name="lock" className={cn('size-3.5 text-fg-tertiary', className)} />
      )}
    </Tooltip>
  );
}
